import type { FetchOptions } from 'ofetch';
import type { IBanner } from '~/libs/types/api/banner';
import type { IPagination } from '~/libs/types/api/pagination';

/**
 * useBanners composable for fetching and managing banners with pagination.
 * @param {Object} params - Parameters for fetching banners.
 * @param {string} params.key - Banner type key for filtering.
 * @param {FetchOptions} [params.options] - Additional fetch options.
 * @returns {Object} - { pending, data, error, refresh }
 */
export const useBanners = async ({ key, options }: { key: string; options?: FetchOptions }) => {
    const isLoading: Ref<boolean> = ref(true)

    const { data, status, error, refresh } = await useAsyncData<IPagination<IBanner[]>>(
        `banners-${key}`,
        () => fetchLocal('/banners', {
            ...options,
            params: {
                ...options?.params,
                filter: { ...options?.params?.filter, type: key }
            }
        }),
        {
            getCachedData(cacheKey: string, nuxtApp: any) {
                return nuxtApp.payload.data[cacheKey] || nuxtApp.static.data[cacheKey];
            },
        }
    );

    const pending = computed(() => ['idle', 'pending'].includes(status.value));

    return { pending, data, error, refresh };
}